import { Component } from '@angular/core';
import { soundpostReportTypeEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Report Types') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostreporttype-form',
    templateUrl: './soundpostreporttype.form.component.html'
})
export class soundpostReportTypeFormComponent extends BaseFormComponent {
    public record!: soundpostReportTypeEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'reportRuns', sectionName: 'Report Runs', isExpanded: false }
        ]);
    }
}

